import { render } from "./referenceArm.vue?vue&type=template&id=7a6475f6&scoped=true"
import script from "./referenceArm.vue?vue&type=script&lang=js"
export * from "./referenceArm.vue?vue&type=script&lang=js"

import "./referenceArm.vue?vue&type=style&index=0&id=7a6475f6&lang=less&scoped=true"

import exportComponent from "D:\\work\\ask_cloud\\QC\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7a6475f6"]])

export default __exports__